module.exports = {"id":"188270","name":"Bruno Ecuélé Manga","rating":"74","photo":"./data/images/photos/4/188270.png","club":{"name":"Cardiff City","logo":"./data/images/clubs/CardiffCity.png"},"positions":["DC","DD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BrunoEcueleManga0.json
// module id = 656
// module chunks = 0